import * as React from 'react';
const SvgChevronUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m15.857 12.956-3.156-3.163a.986.986 0 0 0-1.402 0l-3.156 3.163c-.19.19-.19.51 0 .7l.701.701c.19.19.511.19.701 0L12 11.895l2.455 2.462c.19.19.51.19.7 0l.702-.7c.19-.19.19-.51 0-.701"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronUp;
